(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();

  // ---- tracking -----------------------------------------------------------
  var queue = [];
  var consent = null; // null = unknown, then true/false

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }
  function deliver(item) {
    if (window.__spQA) return;
    var name = item[0], props = item[1];
    if (name === '$tag') {
      try { if (window.posthog && typeof window.posthog.register === 'function') window.posthog.register({ sp_brands_view: props.view }); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('set', 'user_properties', { sp_brands_view: props.view }); } catch (e) {}
      return;
    }
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }
  function send(name, props) {
    if (consent === true) { deliver([name, props]); return; }
    if (consent === false) return;
    if (queue.length < 40) queue.push([name, props]);
  }
  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(deliver);
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  // ---- toggle -------------------------------------------------------------
  function init(root) {
    if (root.hasAttribute('data-sp-bd-ready')) return;
    root.setAttribute('data-sp-bd-ready', '');
    var filters = root.querySelectorAll('[data-sp-bd-filter]');
    var page = root.closest('.sp-brand-dir') || document;
    var current = null;
    var since = 0; // ms timestamp the current group went on top while the tab was visible; 0 = not counting

    function group(key) { return page.querySelectorAll('[data-sp-bd-block="' + key + '"]'); }
    function stopClock() {
      if (!current || !since) return;
      var s = Math.round((Date.now() - since) / 1000);
      since = 0;
      if (s > 0) send('sp_brands_time', { view: current, seconds: s });
    }
    function startClock() { if (current && document.visibilityState === 'visible') since = Date.now(); }

    function select(key, trigger) {
      var top = group(key);
      if (!top.length) return;
      if (key === current) return;
      stopClock();
      // Move the picked group's heading + grid ahead of the first group block on the page.
      var first = page.querySelector('[data-sp-bd-block]');
      if (first && first !== top[0]) {
        top.forEach(function (el) { first.parentNode.insertBefore(el, first); });
      }
      filters.forEach(function (f) {
        f.setAttribute('aria-pressed', f.getAttribute('data-sp-bd-filter') === key ? 'true' : 'false');
      });
      current = key;
      startClock();
      send('sp_brands_view', { view: key, trigger: trigger });
      send('$tag', { view: key });
    }

    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        var key = f.getAttribute('data-sp-bd-filter');
        if (key === current) return; // already on top: a toggle has no "off"
        select(key, 'switch');
        // Bring the newly ordered list into view only if the visitor has scrolled past it.
        var head = group(key)[0];
        if (head && head.getBoundingClientRect().top < 0) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    page.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-sp-bd-block] a[href]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      var g = a.closest('[data-sp-bd-block]').getAttribute('data-sp-bd-block');
      send('sp_brands_click', { view: current, group: g, brand: m ? decodeURIComponent(m[1]).slice(0, 80) : 'other' });
    }, true);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stopClock(); else startClock();
    });
    window.addEventListener('pagehide', stopClock);

    var initial = root.querySelector('[data-sp-bd-filter][aria-pressed="true"]');
    select(initial ? initial.getAttribute('data-sp-bd-filter') : 'artist', 'load');
  }

  function boot() { document.querySelectorAll('[data-sp-bd-shortcuts]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
